import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Breadcrumb,
  Tabs,
  Tab
} from 'react-bootstrap'
import { Link } from 'react-router'

import Details from './company/details'
import Orders from './company/orders'
//import Quotes from './company/quotes'
import Invoices from './company/invoices'
//import Tasks from './company/tasks'
//import Notes from './company/notes'
import CreateQuote from './company/createquote'

@observer(['categories', 'industries', 'contacts', 'organizations', 'companies', 'users', 'companystates', 'addresses'])
export default class Company extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let defaultTab = 1
    switch (this.props.params.companyDetailsTab) {
      case 'invoice':
        defaultTab = 4
        break
    }

    let invoicesTab = ''
    let ordersTab = ''
    let createQuoteTab = ''
    let breadcrumbText = ''

    let linkText = ''
    switch (this.props.companies.details.companyStateId) {
      case 1:
        breadcrumbText = 'Contacts'
        linkText = '/contacts'
        break
      case 2:
        breadcrumbText = 'Leads'
        linkText = '/leads'
        break
      case 3:
        breadcrumbText = 'Customers'
        linkText = '/customers'
        break
      case 4:
        breadcrumbText = 'Inactive'
        linkText = 'inactive'
        break
      case 5:
        breadcrumbText = 'Reseller'
        linkText = 'reseller'
        break
    }

    if (this.props.companies.details.companyStateId == 2 || this.props.companies.details.companyStateId == 3 || this.props.companies.details.companyStateId == 5) { //If the company is a lead, customer, or reseller
      invoicesTab = (
        <Tab eventKey={ 2 } title="Invoices">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
          <Invoices companyId={ this.props.params.companyId } />
          </div>
        </Tab>
      )
      ordersTab = (
        <Tab eventKey={ 3 } title="Orders">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
          <Orders companyId={ this.props.params.companyId } />
          </div>
        </Tab>
      )
      createQuoteTab = (
        <Tab eventKey={ 4 } title="Create Quote">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
          <CreateQuote companyId={ this.props.params.companyId } />
          </div>
        </Tab>
      )
    }

    let menuTabs = (
      <Tabs defaultActiveKey={ defaultTab } id="site-options-tabs">
        <Tab eventKey={ 1 } title="Details">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
          <Details companyId={ this.props.params.companyId } />
          </div>
        </Tab>
        { /*
        <Tab eventKey={ 2 } title="Notes">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
          <Notes companyId={ this.props.params.companyId } />
          </div>
        </Tab>
        <Tab eventKey={ 3 } title="Tasks">
          <div style={
            {
              marginBottom: '20px',
              borderLeft: '1px solid #DDD',
              borderBottom: '1px solid #DDD',
              borderRight: '1px solid #DDD',
              padding: '15px',
              backgroundColor: '#FFF'
            }
          }>
          <Tasks companyId={ this.props.params.companyId } />
          </div>
        </Tab>
        */ }
        { invoicesTab }
        { ordersTab }
        { createQuoteTab }
      </Tabs>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
              <Breadcrumb>
                <Link to="/">Home</Link> / <Link to={ linkText }>{ this.props.companies.details.companyState }</Link> / { this.props.companies.details.name }
              </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          { menuTabs }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company.js